/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
'use client';

import Image, { type ImageProps } from './Image';

const SRCSET_WIDTHS = [320, 640, 768, 1024, 1280, 1536, 1920];

const getUri = (link?: string | null) => {
  if (!link) return '';

  const slug = link
    .replace(process.env.NEXT_PUBLIC_URL || '', '')
    .replace(process.env.NEXT_PUBLIC_WORDPRESS_URL || '', '');

  if (slug.startsWith('http://') || slug.startsWith('https://')) {
    try {
      return new URL(slug).pathname.replace(/\/$/, '') || '/';
    } catch {
      return '/';
    }
  }

  return slug === '/' ? '/' : slug.replace(/\/$/, '');
};

const buildCdnUrl = (src: string, width?: number) => {
  const cdn = process.env.NEXT_PUBLIC_CDN_DOMAIN;
  if (!cdn) return src;

  const normalizedCdn = cdn.replace(/\/$/, '');
  const normalizedSrc = src.replace(/^\//, '');

  const params = new URLSearchParams();
  if (width) params.set('width', String(width));
  params.set('quality', '75');

  return `${normalizedCdn}/${normalizedSrc}?${params.toString()}`;
};

const buildSrcSet = (src: string, maxWidth: number) => {
  const widths = SRCSET_WIDTHS.filter((w) => w <= maxWidth);
  if (!widths.includes(maxWidth)) widths.push(maxWidth);
  return widths.map((w) => `${buildCdnUrl(src, w)} ${w}w`).join(', ');
};

const CDNImage = (props: ImageProps) => {
  if (!process.env.NEXT_PUBLIC_CDN_DOMAIN) {
    return <Image {...props} />;
  }

  const slug = getUri(props.src);
  const cdnSrc = buildCdnUrl(slug, props.width);
  const cdnSrcSet = buildSrcSet(slug, props.width);

  return <Image {...props} src={cdnSrc} srcSet={cdnSrcSet} />;
};

export default CDNImage;
